import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["getHeaderTitle", "actionMetadata", "flowObjectTypeId", "actionId"];
import PropTypes from 'prop-types';
import { Component } from 'react';
import AutomationBuilderCard from 'automation-ui-flow-core/canvas/AutomationBuilderCard';
import SlackActionMetadata from 'automation-ui-action-features/actions/slack/records/SlackActionMetadata';
import SlackActionDetail from 'automation-ui-action-features/actions/slack/SlackActionDetail';
import { jsx as _jsx } from "react/jsx-runtime";
export default class SlackActionCard extends Component {
  render() {
    const _this$props = this.props,
      {
        getHeaderTitle,
        actionMetadata,
        flowObjectTypeId,
        actionId
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    return /*#__PURE__*/_jsx(AutomationBuilderCard, Object.assign({}, rest, {
      headerTitle: getHeaderTitle({
        actionId
      }),
      content: /*#__PURE__*/_jsx(SlackActionDetail, {
        actionMetadata: actionMetadata,
        flowObjectTypeId: flowObjectTypeId
      })
    }));
  }
}
SlackActionCard.propTypes = {
  actionMetadata: PropTypes.instanceOf(SlackActionMetadata).isRequired,
  flowObjectTypeId: PropTypes.string.isRequired,
  getHeaderTitle: PropTypes.func.isRequired,
  actionId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired
};